import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, importProvidersFrom, inject, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withPreloading, withRouterConfig, PreloadAllModules } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxEditorModule } from 'ngx-editor';
import { HammerModule } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { registerLocaleData } from '@angular/common';
import localePTDE from '@angular/common/locales/de';
import moment from 'moment';
import { provideFirebaseApp } from '@angular/fire/app';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { CustomDateAdapter } from './config/custom-date-adapter';
import Locale from './shared/services/locale';
import './firebase';

registerLocaleData(localePTDE);

function localeInitializer() {
  const dateAdapter = inject<DateAdapter<Date>>(DateAdapter);
  return () => {
    moment.locale(Locale.momentLocale());
    dateAdapter.setLocale(Locale.dateAdapterLocale());
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAnimations(),
    importProvidersFrom(MatNativeDateModule, MatTooltipModule, NgxEditorModule, HammerModule),
    provideFirebaseApp(() => (getApps().length ? getApp() : initializeApp(environment.firebaseConfig))),
    provideFirestore(() => getFirestore(getApp())),
    provideStorage(() => getStorage(getApp())),
    { provide: MAT_DATE_LOCALE, useValue: Locale.dateAdapterLocale() },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: APP_INITIALIZER, useFactory: localeInitializer, multi: true },
    { provide: LOCALE_ID, useValue: Locale.dateAdapterLocale() },
  ],
};
